<template>
   <b-card class="order-log-filter mb-4"
    > <b-row
      align-v="end"
      class="order-log-filter__row order-log-filter__row--primary"
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          label="Gian hàng"
          label-for="connection-select"
          class="mb-0"
          > <b-form-select
            id="connection-select"
            class="select-style"
            :value="selectedConnectionId"
            :options="connectionOptions"
            :disabled="loadingConnections"
            @change="onConnectionChange"
            size="sm"
            > <template #first
              > <b-form-select-option :value="null"> -- Tất cả -- </b-form-select-option> </template
            > </b-form-select
          > </b-form-group
        > </b-col
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          label="Mã đơn hàng sàn"
          label-for="external-order-id-input"
          class="mb-0"
          > <b-form-input
            id="external-order-id-input"
            v-model="filters.externalOrderId"
            placeholder="Nhập mã đơn sàn..."
            size="sm"
            @keyup.enter="applyFilters"
          ></b-form-input
          > </b-form-group
        > </b-col
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          label="Tìm Order ID"
          label-for="search-input"
          class="mb-0"
          > <b-form-input
            id="search-input"
            v-model="filters.search"
            placeholder="Nhập Order ID..."
            size="sm"
            @keyup.enter="applyFilters"
          ></b-form-input
          > </b-form-group
        > </b-col
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          label="Mã vận đơn"
          label-for="tracking-number-input"
          class="mb-0"
          > <b-form-input
            id="tracking-number-input"
            v-model="filters.trackingNumber"
            placeholder="Nhập mã vận đơn..."
            size="sm"
            @keyup.enter="applyFilters"
          ></b-form-input
          > </b-form-group
        > </b-col
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          label="Từ ngày"
          label-for="from-date"
          class="mb-0"
          > <date-picker
            id="from-date"
            v-model="filters.fromDate"
            :config="dpConfigs.date"
            class="form-control form-control-sm order-log-filter__date-input"
          ></date-picker
          > </b-form-group
        > </b-col
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          label="Đến ngày"
          label-for="to-date"
          class="mb-0"
          > <date-picker
            id="to-date"
            v-model="filters.toDate"
            :config="dpConfigs.date"
            class="form-control form-control-sm order-log-filter__date-input"
          ></date-picker
          > </b-form-group
        > </b-col
      > </b-row
    > <b-row
      align-v="end"
      class="order-log-filter__row order-log-filter__row--secondary"
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          label="Trạng thái đồng bộ"
          label-for="status-select"
          class="mb-0"
          > <b-form-select
            id="status-select"
            class="select-style"
            v-model="filters.status"
            :options="statusOptions"
            size="sm"
          ></b-form-select
          > </b-form-group
        > </b-col
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          label="Trạng thái đơn hàng"
          label-for="order-status-select"
          class="mb-0"
          > <b-form-select
            id="order-status-select"
            class="select-style"
            v-model="filters.orderStatus"
            :options="orderStatusOptions"
            value-field="value"
            text-field="text"
            size="sm"
          ></b-form-select
          > </b-form-group
        > </b-col
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          label="Loại giao"
          label-for="express-select"
          class="mb-0"
          > <b-form-select
            id="express-select"
            class="select-style"
            v-model="filters.isExpress"
            :options="expressOptions"
            value-field="value"
            text-field="text"
            size="sm"
          ></b-form-select
          > </b-form-group
        > </b-col
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          class="mb-0"
          label-for="has-return-sn-select"
          > <template #label
            > <span
              class="order-log-filter__label-with-hint"
              v-b-tooltip.hover.bottom
              title="Lọc theo danh sách mã đơn trả Shopee (returnOrderSnList) đã đồng bộ"
              > Đơn trả </span
            > </template
          > <b-form-select
            id="has-return-sn-select"
            class="select-style"
            v-model="filters.hasReturnSnList"
            :options="hasReturnSnListOptions"
            value-field="value"
            text-field="text"
            size="sm"
          ></b-form-select
          > </b-form-group
        > </b-col
      > <b-col
        cols="12"
        sm="6"
        xl="2"
        > <b-form-group
          label="IMEI"
          label-for="imei-code-input"
          class="mb-0"
          > <b-form-input
            id="imei-code-input"
            v-model="filters.imeiCode"
            placeholder="Mã IMEI dòng hàng..."
            size="sm"
            @keyup.enter="applyFilters"
          ></b-form-input
          > </b-form-group
        > </b-col
      > </b-row
    > <b-row
      align-v="end"
      class="order-log-filter__row"
      > <b-col
        cols="12"
        sm="6"
        xl="4"
        > <b-form-group
          label-for="product-name-input"
          class="mb-0"
          > <template #label
            > <span
              class="order-log-filter__label-with-hint"
              v-b-tooltip.hover.bottom
              title="Tìm trong dòng hàng Shopee (item_name, SKU, model…)"
              > Tên sản phẩm </span
            > </template
          > <b-form-input
            id="product-name-input"
            v-model="filters.productName"
            placeholder="VD: iPhone, SKU..."
            size="sm"
            @keyup.enter="applyFilters"
          ></b-form-input
          > </b-form-group
        > </b-col
      > <b-col
        cols="12"
        sm="6"
        xl="4"
        > <b-form-group
          label-for="logistics-input"
          class="mb-0"
          > <template #label
            > <span
              class="order-log-filter__label-with-hint"
              v-b-tooltip.hover.bottom
              title="Đơn vị vận chuyển / kênh logistics (danh sách từ Shopee)"
              > ĐVVC / kênh VC </span
            > </template
          > <BDropdownCustom
            id="logistics-channel-select"
            dropdown-id="order-log-logistics-select"
            :value="selectedLogistics"
            :options="logisticsOptions"
            :placeholder="'ĐVVC / kênh VC'"
            :searchable="true"
            :matchKey="['name', 'shortName']"
            :compareById="true"
            :loading="loadingLogisticsOptions"
            @valueChange="onLogisticsSelectionChange"
            @open="$emit('logistics-dropdown-open')"
          /> </b-form-group
        > </b-col
      > </b-row
    > <b-row class="order-log-filter__actions-row"
      > <b-col
        >
        <div class="d-flex align-items-center flex-wrap order-log-filter__actions">
           <b-button
            size="sm"
            variant="primary"
            @click="applyFilters"
            > <i class="flaticon2-search-1 mr-1"></i> Lọc </b-button
          > <b-button
            size="sm"
            variant="secondary"
            @click="resetFilters"
            title="Xóa bộ lọc"
            > <i class="flaticon2-refresh mr-1"></i> Xóa lọc </b-button
          > <b-button
            v-if="checkPermissions(['ORDER_VIEW'])"
            size="sm"
            variant="outline-primary"
            @click="$emit('export-order-logs-excel')"
            :disabled="exportingOrderLogs || !selectedConnectionId || loadingConnections"
            title="Xuất Excel theo bộ lọc hiện tại (GET orders/logs/export)"
            > <b-spinner
              v-if="exportingOrderLogs"
              small
              class="mr-1"
            ></b-spinner
            > <i
              v-else
              class="far fa-file-excel mr-1"
            ></i
            > {{ exportingOrderLogs ? 'Đang xuất...' : 'Xuất Excel' }} </b-button
          > <b-button
            size="sm"
            variant="success"
            @click="triggerSync"
            :disabled="syncing || !selectedConnectionId"
            > <b-spinner
              v-if="syncing"
              small
              class="mr-1"
            ></b-spinner
            > <i
              v-else
              class="flaticon2-refresh-1 mr-1"
            ></i
            > {{ syncing ? 'Đang đồng bộ...' : 'Đồng bộ' }} </b-button
          > <b-button
            size="sm"
            variant="outline-primary"
            @click="$emit('sync-by-order-sn')"
            :disabled="syncing || !selectedConnectionId"
            title="Sync đơn hàng theo mã Order Sn"
            > <i class="flaticon2-add-1 mr-1"></i> Sync theo Order Sn </b-button
          > <b-button
            size="sm"
            variant="outline-secondary"
            @click="$emit('print-tracking-by-order-sn')"
            :disabled="printingTracking || !selectedConnectionId"
            title="In mã vận đơn theo Order Sn"
            > <b-spinner
              v-if="printingTracking"
              small
              class="mr-1"
            ></b-spinner
            > <i
              v-else
              class="flaticon2-print mr-1"
            ></i
            > In mã vận đơn </b-button
          > <b-button
            size="sm"
            variant="outline-dark"
            @click="$emit('print-tracking-batch')"
            :disabled="printingTrackingBatch || !canPrintBatch"
            title="In nhiều đơn đã chọn"
            > <b-spinner
              v-if="printingTrackingBatch"
              small
              class="mr-1"
            ></b-spinner
            > <i
              v-else
              class="flaticon2-layers-1 mr-1"
            ></i
            > {{ printingTrackingBatch ? 'Đang in...' : `In đã chọn (${selectedPrintCount})` }}
            </b-button
          > <b-button
            v-if="checkPermissions(['ORDER_UPDATE'])"
            size="sm"
            variant="outline-success"
            @click="$emit('bulk-select-ready-to-ship')"
            :disabled="bulkCreatingShipment || !selectedConnectionId || loadingConnections"
            title="Lọc READY_TO_SHIP + đã đồng bộ và tick chọn các đơn trên trang (không gọi API). Sau đó dùng menu «Đã chọn» để xác nhận."
            > <i class="flaticon2-box mr-1"></i> Chọn đơn READY_TO_SHIP </b-button
          > <b-button
            size="sm"
            variant="outline-info"
            class="ml-1"
            @click="$emit('select-all-shipment-by-filter')"
            :disabled="
              bulkCreatingShipment ||
              resolvingShipmentSelectAll ||
              !selectedConnectionId ||
              loadingConnections
            "
            title="Resolve mã đơn theo đúng filter (mọi trang), rồi dùng Đã chọn → Xác nhận shipment."
            ><b-spinner v-if="resolvingShipmentSelectAll" small class="mr-1"></b-spinner><i
              v-else
              class="flaticon2-list-2 mr-1"
            ></i
            > {{
              resolvingShipmentSelectAll ? 'Đang resolve...' : 'Chọn theo filter (mọi trang)'
            }}</b-button
          > <b-dropdown
            v-if="checkPermissions(['ORDER_UPDATE'])"
            size="sm"
            variant="warning"
            class="ml-1 order-log-filter__batch-status-dd"
            right
            :disabled="selectedPrintCount === 0"
            title="Thao tác trên các dòng đã tick chọn"
            > <template slot="button-content"
              > <span class="font-weight-bolder"
                > <span class="count-status badge badge-circle badge-white mr-1">{{
                  selectedChangeStatusCount
                }}</span
                > Đã chọn </span
              > </template
            > <b-dropdown-item
              @click="$emit('change-internal-order-status-batch')"
              :disabled="!canChangeStatusBatch"
              > <i class="fas fa-sync-alt mr-1"></i> Đổi trạng thái </b-dropdown-item
            > <b-dropdown-item
              @click="$emit('bulk-create-shipment')"
              :disabled="!canBulkCreateShipment || bulkCreatingShipment"
              > <span style="color: #3f4254; font-size: 12px"
                > <i
                  style="font-size: 1rem"
                  class="flaticon2-box mr-1"
                ></i
                > Tạo shipment đã chọn <span
                  v-if="selectedBulkCreateShipmentCount > 0"
                  class="text-muted"
                  > ({{ selectedBulkCreateShipmentCount }})</span
                > </span
              > </b-dropdown-item
            > <b-dropdown-item
              @click="$emit('bulk-confirm-ship-order')"
              :disabled="!canBulkConfirmShipOrder || bulkCreatingShipment"
              > <span style="color: #3f4254; font-size: 12px"
                > <i
                  style="font-size: 1rem"
                  class="flaticon2-check-mark mr-1"
                ></i
                > Xác nhận ship_order đã chọn <span
                  v-if="selectedBulkConfirmShipCount > 0"
                  class="text-muted"
                  > ({{ selectedBulkConfirmShipCount }})</span
                > </span
              > </b-dropdown-item
            > </b-dropdown
          > <span
            v-if="syncQueueSummaryText"
            class="text-12 text-muted ml-3 align-middle"
            >{{ syncQueueSummaryText }}</span
          >
        </div>
         </b-col
      > </b-row
    > </b-card
  >
</template>

<script>
  import { ORDER_STATUS_OPTIONS, ORDER_STATUS_FILTER_OPTIONS } from '../constants'
  import { DP_CONFIG } from '@/utils/date'
  import { checkPermissions } from '@/utils/saveDataToLocal'
  import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue'

  export default {
    name: 'OrderLogFilter',
    components: {
      BDropdownCustom,
    },
    props: {
      syncing: {
        type: Boolean,
        default: false,
      },
      printingTracking: {
        type: Boolean,
        default: false,
      },
      printingTrackingBatch: {
        type: Boolean,
        default: false,
      },
      selectedPrintCount: {
        type: Number,
        default: 0,
      },
      canPrintBatch: {
        type: Boolean,
        default: false,
      },
      bulkCreatingShipment: {
        type: Boolean,
        default: false,
      },
      resolvingShipmentSelectAll: {
        type: Boolean,
        default: false,
      },
      exportingOrderLogs: {
        type: Boolean,
        default: false,
      },
      connections: {
        type: Array,
        default: () => [],
      },
      selectedConnectionId: {
        type: [Number, String],
        default: null,
      },
      loadingConnections: {
        type: Boolean,
        default: false,
      },
      initialFilters: {
        type: Object,
        default: null,
      },
      syncQueueCounts: {
        type: Object,
        default: null,
      },
      selectedChangeStatusCount: {
        type: Number,
        default: 0,
      },
      canChangeStatusBatch: {
        type: Boolean,
        default: false,
      },
      selectedBulkCreateShipmentCount: {
        type: Number,
        default: 0,
      },
      canBulkCreateShipment: {
        type: Boolean,
        default: false,
      },
      selectedBulkConfirmShipCount: {
        type: Number,
        default: 0,
      },
      canBulkConfirmShipOrder: {
        type: Boolean,
        default: false,
      },
      logisticsOptions: {
        type: Array,
        default: () => [],
      },
      loadingLogisticsOptions: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        selectedLogistics: [],
        filters: {
          search: '',
          externalOrderId: '',
          status: null,
          orderStatus: null,
          externalStatus: null,
          isExpress: null,
          hasReturnSnList: null,
          trackingNumber: '',
          imeiCode: '',
          productName: '',
          logistics: '',
          logisticsChannelId: null,
          fromDate: null,
          toDate: null,
        },
        statusOptions: ORDER_STATUS_OPTIONS,
        orderStatusOptions: ORDER_STATUS_FILTER_OPTIONS,
        expressOptions: [
          { value: null, text: 'Tất cả' },
          { value: true, text: 'Hỏa tốc' },
          { value: false, text: 'Thường' },
        ],
        hasReturnSnListOptions: [
          { value: null, text: 'Tất cả' },
          { value: true, text: 'Có đơn trả' },
          { value: false, text: 'Không có đơn trả' },
        ],
        dpConfigs: DP_CONFIG,
      }
    },
    computed: {
      connectionOptions() {
        return this.connections.map((c) => ({
          value: c.id,
          text: c.shopName || `Shop ${c.shopId}`,
        }))
      },
      syncQueueSummaryText() {
        if (!this.selectedConnectionId || !this.syncQueueCounts) return ''
        const c = this.syncQueueCounts
        const waiting = Number(c.waiting) || 0
        const active = Number(c.active) || 0
        const delayed = Number(c.delayed) || 0
        const total = waiting + active + delayed
        if (total <= 0) return ''
        return `Hàng đợi đồng bộ — chờ: ${waiting}, đang xử lý: ${active}, hoãn: ${delayed}`
      },
    },
    watch: {
      initialFilters: {
        handler(val) {
          if (val && typeof val === 'object') {
            this.filters = {
              search: val.search !== undefined ? val.search : '',
              externalOrderId: val.externalOrderId !== undefined ? val.externalOrderId : '',
              status: val.status !== undefined ? val.status : null,
              orderStatus: val.orderStatus !== undefined ? val.orderStatus : null,
              externalStatus: val.externalStatus !== undefined ? val.externalStatus : null,
              isExpress: val.isExpress !== undefined ? val.isExpress : null,
              hasReturnSnList: val.hasReturnSnList !== undefined ? val.hasReturnSnList : null,
              trackingNumber: val.trackingNumber !== undefined ? val.trackingNumber : '',
              imeiCode: val.imeiCode !== undefined ? val.imeiCode : '',
              productName: val.productName !== undefined ? val.productName : '',
              logistics: val.logistics !== undefined ? val.logistics : '',
              logisticsChannelId:
                val.logisticsChannelId !== undefined && val.logisticsChannelId !== ''
                  ? val.logisticsChannelId
                  : null,
              fromDate: val.fromDate !== undefined ? val.fromDate : null,
              toDate: val.toDate !== undefined ? val.toDate : null,
            }
            this.syncSelectedLogisticsFromFilter()
          }
        },
        immediate: true,
        deep: true,
      },
      logisticsOptions: {
        handler() {
          this.syncSelectedLogisticsFromFilter()
        },
      },
      selectedConnectionId() {
        this.selectedLogistics = []
        this.filters.logisticsChannelId = null
        this.filters.logistics = ''
      },
    },
    methods: {
      syncSelectedLogisticsFromFilter() {
        const channelId =
          this.filters.logisticsChannelId != null && this.filters.logisticsChannelId !== ''
            ? String(this.filters.logisticsChannelId)
            : ''
        if (!channelId) {
          this.selectedLogistics = []
          return
        }
        const matched = (this.logisticsOptions || []).find(
          (opt) => String(opt.id ?? opt.logisticsChannelId) === channelId,
        )
        this.selectedLogistics = matched ? [matched] : []
      },
      onLogisticsSelectionChange(next) {
        this.selectedLogistics = Array.isArray(next) ? next.slice(0, 1) : []
        const picked = this.selectedLogistics[0]
        if (picked) {
          this.filters.logisticsChannelId = picked.id ?? picked.logisticsChannelId ?? null
          this.filters.logistics = ''
        } else {
          this.filters.logisticsChannelId = null
          this.filters.logistics = ''
        }
      },
      applyFilters() {
        this.$emit('apply-filters', { ...this.filters })
      },
      resetFilters() {
        this.filters = {
          search: '',
          externalOrderId: '',
          status: null,
          orderStatus: null,
          externalStatus: null,
          isExpress: null,
          hasReturnSnList: null,
          trackingNumber: '',
          imeiCode: '',
          productName: '',
          logistics: '',
          logisticsChannelId: null,
          fromDate: null,
          toDate: null,
        }
        this.selectedLogistics = []
        this.$emit('apply-filters', { ...this.filters })
      },
      triggerSync() {
        this.$emit('trigger-sync')
      },
      checkPermissions,
      onConnectionChange(connectionId) {
        this.$emit('connection-change', connectionId)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .order-log-filter {
  background: white;
  border-radius: 0.42rem;
  padding: 1rem;
  border: 1px solid #ebedf3;
  box-shadow: none;

  ::v-deep .form-group {
    margin-bottom: 0;

    label {
      font-weight: 600;
      font-size: 0.8125rem;
      color: #3f4254;
      margin-bottom: 0.35rem;
      display: block;
    }
  }

  ::v-deep .form-control,
  ::v-deep .custom-select {
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    transition: all 0.2s ease;

    &:focus {
      border-color: #3699ff;
      box-shadow: none;
    }

    &:hover:not(:disabled) {
      border-color: #b5b5c3;
    }
  }

  ::v-deep .form-control-sm {
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    height: calc(1.5em + 0.75rem + 2px);
  }

  ::v-deep .custom-select-sm {
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    font-size: 0.875rem;
    height: calc(1.5em + 0.75rem + 2px);
  }

  ::v-deep .order-log-filter__date-input {
    height: calc(1.5em + 0.75rem + 2px);
    min-height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
  }

  &__row {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    margin-bottom: 0.6rem;

    > [class*='col-'] {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      margin-bottom: 0.35rem;
    }
  }

  &__row--secondary {
    padding-top: 0.75rem;
    margin-top: 0.2rem;
    margin-bottom: 0.45rem;
    border-top: 1px solid #ebedf3;
  }

  &__label-with-hint {
    cursor: help;
    border-bottom: 1px dotted #b5b5c3;
  }

  &__actions-row {
    margin-top: 0.4rem;
    padding-top: 0.35rem;
    border-top: 1px solid #f1f3f8;
  }

  &__actions > * {
    margin-right: 0.5rem;
    margin-bottom: 0.35rem;
  }

  &__actions > *:last-child {
    margin-right: 0;
  }

  /* Căn chiều cao dropdown "Đã chọn" với các b-button size="sm" cùng hàng */
  &__actions ::v-deep .order-log-filter__batch-status-dd .dropdown-toggle.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    min-height: calc(1.5em + 0.75rem + 2px);
    box-sizing: border-box;
    line-height: 1.5;
  }

  &__actions ::v-deep .order-log-filter__batch-status-dd .dropdown-toggle.btn::after {
    margin-top: 0;
    vertical-align: middle;
    align-self: center;
  }

  &__actions ::v-deep .order-log-filter__batch-status-dd .count-status.badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.125rem;
    height: 1.125rem;
    padding: 0 0.25rem;
    font-size: 0.6875rem;
    line-height: 1;
    border-radius: 0.28rem;
  }

  .btn {
    border-radius: 0.28rem;
    font-weight: 600;
    padding: 0.375rem 0.8rem;
    transition: all 0.2s ease;
    box-shadow: none;

    &:hover:not(:disabled) {
      transform: none;
      box-shadow: none;
    }

    i {
      font-size: 0.875rem;
    }
  }

  .btn-primary {
    background: #3699ff;
    border-color: #3699ff;
  }

  .btn-secondary {
    background: #f3f6f9;
    border-color: #e4e6ef;
    color: #3f4254;

    &:hover:not(:disabled) {
      background: #ebedf3;
      border-color: #d1d3e0;
    }
  }

  .btn-success {
    background: #1bc5bd;
    border-color: #1bc5bd;
  }
}

// Responsive adjustments
@media (max-width: 768px) {
  .order-log-filter {
    padding: 1rem;

    &__row > [class*='col-'] {
      margin-bottom: 0.75rem;
    }
  }
}
</style>

